import React from "react";
import Plan from "../../components/plans";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";

const Price = ()=>{
    const { t } = useTranslation('common')
    return(
        <div className='price-wrap'>
            <Helmet>
                <title>تعرفه بل میت</title>
                <meta name="description" content="پلن ها و تعرفه های بل میت را می توانید از این بخش مشاهده کنید." />
            </Helmet>
            <Nav />
            <div className={'webinar-dec'}>
              <h1>{t('Tariffs')}</h1>
              <Plan />
            </div>
            <Footer />
        </div>
    )
}

export default Price